import React from 'react';

export default ({ color = '#23E771', size = 12, }: { color: string; size?: number; }): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="6" fill={color} />
    <path
      d="M3.4901 5.98509L5.15408 7.64906L8.48202 4.32111"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
